import { useState, useEffect } from 'react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navItems = [
    { label: '首页', href: '#hero' },
    { label: '热门话题', href: '#topics' },
    { label: '特色优势', href: '#features' },
    { label: '移动入口', href: '#app' },
    { label: '吃瓜榜单', href: '#ranking' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6 flex items-center justify-between h-[72px]">
        <a
          href="#hero"
          className="flex items-center gap-2 shrink-0 no-underline"
        >
          <span className="text-2xl md:text-3xl font-heading text-primary-500">
            爆料吃瓜
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer ${
                item.label === '首页'
                  ? 'text-foreground-800 hover:text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#contact"
            className="whitespace-nowrap px-5 py-2.5 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-send-plane-line mr-1.5"></i>
            我要爆料
          </a>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-200 transition-colors cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 flex flex-col gap-2">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setMobileOpen(false)}
              className={`whitespace-nowrap px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                item.label === '首页'
                  ? 'text-foreground-800'
                  : 'text-foreground-700 hover:bg-primary-50 hover:text-primary-500'
              }`}
            >
              {item.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setMobileOpen(false)}
            className="whitespace-nowrap mt-2 px-5 py-3 rounded-full text-sm font-semibold bg-primary-500 text-background-50 text-center hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-send-plane-line mr-1.5"></i>
            我要爆料
          </a>
        </div>
      )}
    </header>
  );
}